import React from 'react';
export function TastingMenu() {
  const courses = [{
    course: 'First',
    name: 'Seasonal Appetizer Trio',
    description: "Chef's selection of three seasonal bites"
  }, {
    course: 'Second',
    name: 'Sashimi Selection',
    description: 'Five kinds of fresh fish with traditional accompaniments'
  }, {
    course: 'Third',
    name: 'Grilled Dish',
    description: 'Miso-marinated fish or premium wagyu beef'
  }, {
    course: 'Fourth',
    name: 'Signature Hot Pot',
    description: 'Shabu-shabu or sukiyaki with seasonal vegetables'
  }, {
    course: 'Fifth',
    name: 'Sushi Course',
    description: 'Eight pieces of nigiri featuring seasonal highlights'
  }, {
    course: 'Sixth',
    name: 'Palate Cleanser',
    description: 'Yuzu sorbet with fresh mint'
  }, {
    course: 'Seventh',
    name: 'Dessert',
    description: 'Matcha tiramisu or black sesame panna cotta'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-950" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4" data-id="element-128">
            Omakase Tasting Menu
          </h2>
          <p className="text-xl text-gray-300 mb-6" data-id="element-129">
            A seven-course journey through Japanese culinary artistry
          </p>
          <div className="inline-block" data-id="element-130">
            <p className="text-3xl font-bold text-amber-400" data-id="element-131">$125 per person</p>
            <p className="text-sm text-gray-400 mt-2" data-id="element-132">
              Wine pairing available +$65
            </p>
          </div>
        </div>

        <div className="space-y-8" data-id="element-133">
          {courses.map((item, index) => <div key={index} className="border-l-4 border-amber-400 pl-6 py-4 hover:border-amber-300 transition-colors bg-black/30 rounded-r-lg" data-id="element-134">
              <div className="flex items-baseline gap-4 mb-2" data-id="element-135">
                <span className="text-sm font-semibold text-amber-400 uppercase tracking-wider" data-id="element-136">
                  {item.course} Course
                </span>
                <h3 className="text-2xl font-semibold text-white" data-id="element-137">
                  {item.name}
                </h3>
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-138">
                {item.description}
              </p>
            </div>)}
        </div>

        <div className="mt-12 p-6 bg-black border border-amber-900/30 rounded-xl" data-id="element-139">
          <p className="text-gray-300 text-center" data-id="element-140">
            <span className="text-amber-400 font-semibold" data-id="element-141">Please note:</span>{' '}
            Our tasting menu requires 24-hour advance notice and is available
            for parties of 2-8 guests. Dietary restrictions can be accommodated
            with advance notice.
          </p>
        </div>
      </div>
    </section>;
}